import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TalentTypeLookupComponent } from './talent-type-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [TalentTypeLookupComponent],
  exports: [TalentTypeLookupComponent],
  providers: []
})
export class TalentTypeLookupModule { }
